import { useEffect } from 'react';

export const useUpdatesStatus = (getUpdatesRequest, getDevicesUpdatesRequest) => {
    useEffect(() => {
        getUpdatesRequest();
        getDevicesUpdatesRequest();

        const timer = setInterval(() => {
            getUpdatesRequest();
            getDevicesUpdatesRequest();
        }, 3.6e6);

        return () => clearInterval(timer);
    }, []);
};
